import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import LoadingScreen from "./components/common/LoadingScreen";
import * as paths from "./constants/paths";

const SubscriptionProtectedRoute = ({ restrictedPlans, allowedPlans }) => {
  const isSiteSettingsLoading = useSelector(
    (state) => state.fetchSiteSettings.isLoading,
  );
  const activePlan = useSelector((state) => state.fetchSiteSettings.activePlan);

  if (isSiteSettingsLoading) {
    return <LoadingScreen />;
  }

  // if (!activePlan || restrictedPlans.includes(Number(activePlan?.plan_id))) {
  //   return <Navigate to={`${paths.SITE_BASE_URL}/subscription`} replace />;
  // }
  const planId = Number(activePlan?.plan_id);
  if (restrictedPlans) {
    if (!activePlan || restrictedPlans.includes(planId)) {
      return <Navigate to={`${paths.SITE_BASE_URL}/subscription`} replace />;
    }
  }

  if (allowedPlans) {
    if (!activePlan || !allowedPlans.includes(planId)) {
      return <Navigate to={`${paths.SITE_BASE_URL}/subscription`} replace />;
    }
  }

  return <Outlet />;
};

export default SubscriptionProtectedRoute;
